import { memo, useState } from "react"
import { CalendarTooltipPortal } from "../CalendarTooltipPortal"
import { ResourceBookingCalendarTooltipContent } from "./ResourceBookingCalendarTooltipContent"

export type ResourceBookingCalendarHoveredEvent = {
    id: string
    top: number
    left: number
    local: boolean
    start?: string
    end?: string
    host?: string
    subject?: string
}

type HoverTooltipLayerProps = Readonly<{
    isDraggingRef: React.RefObject<boolean>
    setHoverRef: React.MutableRefObject<(event: ResourceBookingCalendarHoveredEvent | null) => void>
}>

export const HoverTooltipLayer = memo(function HoverTooltipLayer({
    isDraggingRef,
    setHoverRef,
}: HoverTooltipLayerProps) {
    const [hoveredEvent, setHoveredEvent] = useState<ResourceBookingCalendarHoveredEvent | null>(null)
    setHoverRef.current = setHoveredEvent

    if (!hoveredEvent || isDraggingRef.current) return null

    return (
        <CalendarTooltipPortal topPx={hoveredEvent.top} leftPx={hoveredEvent.left}>
            <ResourceBookingCalendarTooltipContent hoveredEvent={hoveredEvent} />
        </CalendarTooltipPortal>
    )
})
